import { QueryClient } from '@tanstack/react-query'
import { isAuthSessionExpiredError } from '@/app/auth/session-expired-error'

/**
 * React Query defaults tuned for the OMS ops table:
 *
 * - `staleTime: 30s` — operators scan a page, walk away, come back. 30s
 *   keeps the queue fresh without hammering Vision on every focus flip.
 * - `refetchOnWindowFocus: false` — a row jumping while the operator is
 *   mid-click is a bug, not a feature.
 * - `refetchOnReconnect: true` — a laptop sleep should catch back up.
 * - `retry: 1` — network flakes get one shot; auth failures escape
 *   immediately so the MSAL redirect can fire.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (isAuthSessionExpiredError(error)) return false
        const status = (error as { status?: number } | null)?.status
        if (status === 401 || status === 403 || status === 404) return false
        return failureCount < 1
      },
    },
    mutations: {
      retry: false,
    },
  },
})
